import React from 'react';
import { MessageCircle, ExternalLink } from 'lucide-react';
const friendLinks = [{
  name: 'TTvip',
  url: 'https://ttvip-64.com/'
}, {
  name: 'Shiok27',
  url: 'https://shiok27.com/'
}, {
  name: 'XFY01',
  url: 'https://xfy01.net/'
}, {
  name: 'SGHarem',
  url: 'https://sgharem6.net/'
}, {
  name: 'QC52',
  url: 'https://qc52.me/'
}, {
  name: 'SGLonelyGuy',
  url: 'https://sglonelyguy.me'
}, {
  name: 'TTvip Life',
  url: 'https://ttvip.life'
}, {
  name: 'Locanto',
  url: 'https://locanto.space'
}, {
  name: 'KKbaby',
  url: 'https://kkbaby.site'
}, {
  name: 'XFY8',
  url: 'https://xfy8.com'
}, {
  name: 'SG Beauty Castle',
  url: 'https://sgbeautycastle.live'
}, {
  name: 'Shiok26',
  url: 'https://shiok26.site'
}, {
  name: 'SGHarem',
  url: 'https://sgharem.site'
}, {
  name: 'Shiok8',
  url: 'https://shiok8.xyz'
}, {
  name: 'Geylang777',
  url: 'https://geylang777.info'
}, {
  name: 'TTvip-62',
  url: 'https://ttvip-62.site'
}, {
  name: 'Geylang666',
  url: 'https://geylang666.me'
}, {
  name: 'Isyou',
  url: 'https://isyou.net'
}];
export function Footer() {
  return <footer className="bg-[#050505] border-t border-[#1a1a1a] py-12" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8" data-id="element-41">
          <div className="text-center md:text-left" data-id="element-42">
            <h2 className="text-2xl font-serif text-white mb-2" data-id="element-43">KKbaby</h2>
            <p className="text-gray-500 text-sm" data-id="element-44">
              Your Trusted Companion in Singapore
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-4" data-id="element-45">
            <button className="flex items-center gap-2 px-6 py-3 bg-[#D4AF37] text-black font-medium rounded hover:bg-[#C5A55A] transition-colors" data-id="element-46">
              <MessageCircle className="w-5 h-5" data-id="element-47" />
              <span data-id="element-48">Contact Us</span>
            </button>
          </div>
        </div>

        {/* Friend Links */}
        <div className="mt-10 pt-8 border-t border-[#1a1a1a]" data-id="element-49">
          <p className="text-center text-xs text-gray-600 mb-4 tracking-widest uppercase" data-id="element-50">
            友情链接 · Partner Sites
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-51">
            {friendLinks.map(link => <a key={link.name} href={link.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 px-4 py-2 text-sm text-gray-400 border border-[#222] hover:border-[#D4AF37]/50 hover:text-[#D4AF37] transition-colors duration-300" data-id="element-52">
                {link.name}
                <ExternalLink className="w-3 h-3 opacity-50" data-id="element-53" />
              </a>)}
          </div>
        </div>

        <p className="text-xs text-gray-600 text-center mt-8" data-id="element-54">
          © {new Date().getFullYear()} KKbaby. All rights reserved. 18+ Only.
        </p>
      </div>
    </footer>;
}